export default __webpack_public_path__ + "06ca275c3b1f99f93a3742c5b223bfa7.png";